import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../modules/infra/i18n';
import CancelButton from '../../../common/buttons/cancelButton';
import { inputParseFn } from '../../../common/helpers/inputs';
import Input from '../../../common/input';
import Modal from '../../../common/Modal';
import Select from '../../../common/select';
import Textarea from '../../../common/textarea';
import { ECOMMERCE_INTEGRATION_ACTION, INVENTORY_ACTIONS } from '../constants';

const getInventoryActions = () =>
  INVENTORY_ACTIONS.filter((action) => action.value !== ECOMMERCE_INTEGRATION_ACTION).map((action) => ({
    ...action,
    label: t(action.labelKey),
  }));

const InventoryModal = (props) => {
  const { close, product, submitting, stopPropagationAndSubmit } = props;

  return (
    <Modal close={close} showCloseButton title={`${t('products:inventory_modal.title')} – ${product.name}`}>
      <div className="s-v2 u-ph+ u-pt u-pb+">
        <div className="layout layout--large">
          <form onSubmit={stopPropagationAndSubmit}>
            <fieldset disabled={submitting}>
              <div className="layout__item">
                <span className="c-label-new u-fontsize-small">
                  {t('products:inventory_modal.current_inventory_count')}: {product.inventory}
                </span>
              </div>
              <div className="layout__item u-1/2-medium-and-up">
                <span className="c-label-new">{t('products:inventory_modal.new_inventory_count')}</span>
                <div className="layout layout--middle">
                  <div className="layout__item">
                    <Input
                      className="c-input c-input--border c-input--v3"
                      name="quantity"
                      type="number"
                      parse={inputParseFn}
                    />
                  </div>
                </div>
              </div>

              <div className="layout__item u-1/2-medium-and-up">
                <span className="c-label-new">{t('products:inventory_modal.reason_for_change')}</span>
                <Select
                  name="action"
                  className="c-select c-select--v3"
                  empty={t('products:inventory_modal.select_reason')}
                  options={getInventoryActions()}
                />
              </div>

              <div className="layout__item u--mt">
                <span className="c-label-new">{t('products:inventory_modal.notes')}</span>
                <Textarea
                  className="c-input c-input--border c-input--v3"
                  name="description"
                  type="text"
                  placeholder={t('products:inventory_modal.enter_notes')}
                />
              </div>
              <div className="u-text-right u-mb+">
                <CancelButton onClick={close} content={t('products:inventory_modal.cancel_button')} />
                <button type="submit" className="c-btn u-width-120 u-ml-">
                  <span className="c-btn__text">{t('products:inventory_modal.save_button')}</span>
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </Modal>
  );
};

InventoryModal.propTypes = {
  close: PropTypes.func.isRequired,
  stopPropagationAndSubmit: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default InventoryModal;
